module.exports = __webpack_public_path__ + "static/bottom-997abe5c8722a9b78672f9a7fb0b9b06.png";